<template>
<div v-if="this.$store.state.user.userinfo.id && !$store.state.user.check_is_wxc_domain()">
    <div class="fixed-bottom col-md-2 user-help  text-center mb-3 p-3"  @click="openModal()">
        <i class="el-icon-service ml-1 f"></i>
        <span class="title font-weight-normal">
    <!--        <span class="mr-3" v-html="icons.helpcenter"></span>-->
            <span class="help-title text-dark m-2"> {{ $t('message').topnav.customer_service }}</span>
          </span>
      </div>
  <modal :show.sync="modals.sendQqhModal" headerClasses="justify-content-center">
    <h4 slot="header" class="title title-up" style="padding-top:5px">{{$t('message').qqh.modal_title_prefix}} 海外官博 {{$t('message').qqh.modal_title}}</h4>
    <div class="datepicker-container d-flex justify-content-center">
      <el-input
          type="textarea"
          :rows="3"
          :placeholder="$t('message').qqh.modal_placeholder"
          v-model="modals.qqhMsgbody">
      </el-input>
    </div>
    <template slot="footer">
      <span v-if="modals.modalData" :class="{'text-success':modals.modalData.status,'text-danger':!modals.modalData.status,}">{{modals.modalData.status?$t('message').qqh.modal_succese:modals.modalData.error}}</span>
      <n-button
          class="mr-3"
          type="default"
          link
          @click="modals.sendQqhModal = false"
      >
        {{$t('message').qqh.modal_btn_cancel}}
      </n-button>
      <n-button
          type="primary"
          round
          simple
          @click.native="sendQqh(data)"
      >
        {{$t('message').qqh.modal_btn_send}}
      </n-button>
    </template>
  </modal>
</div>
</template>
<script>
import {
  Button,
  Modal,
} from '@/components';
export default {
  name: "CustomerService",
  components: {
    [Button.name]: Button,
    Modal,
  },
  methods: {
    openModal() {
      if (this.$store.state.user.userinfo.UserID !== undefined) {
        this.modals.sendQqhModal = true
      } else {
        this.$router.push({path:"/login",query:{redirect: this.$route.fullPath}})
      }
    },
    sendQqh(data) {
      this.send(2000004, this.modals.qqhMsgbody);


    },
    async send(touserID, msgbody) {
      let user = this.$store.state.user;
      let res = await user.sendQqh(touserID, msgbody);

      this.modals.modalData = res

      setTimeout(() => {
        this.modals.modalData = undefined;
        this.modals.sendQqhModal = res.status ? false : true;
      }, 4);
      if (res.status) {
        this.$message.success("您的悄悄话已发送！");
      }
      else {
        this.$message.warning(res.error);
      }
    },
  },
  data() {
    return {
      user: this.$store.state.user,
      // userID: this.$route.params.id,
      bloggerID: 0,
      userinfo: {
        bloggerinfo_bloggerID: false
      },
      data: this.info,
      modals: {
        sendQqhModal: false,
        qqhMsgbody: '',
        modalData: undefined
      },
    };
  },
}
</script>

<style scoped>
.user-help {
  background-color: #fff;
  border: 2px solid;
  border-color: #c3e1ed54;
  left: 30px;
  cursor: pointer;
}
.user-help:hover {
  background-color: #ecf5ff;
  border-color: #d9ecff;
}
</style>